import React, { useEffect } from 'react';
import './styles/index.css';
import { CartProvider } from './context/CartContext';
import AppRoutes from './routes/AppRoutes';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out-quad',
      offset: 50,
      disableMutationObserver: false,
      anchorPlacement: 'top-bottom',
    });
  }, []);

  return (
    <CartProvider>
      <AppRoutes />
    </CartProvider>
  );
}

export default App;
